import { createActionGroup, props } from '@ngrx/store';

export const PoaPadResultComponentActions = createActionGroup({
  source: 'Pad Result Component',
  events: {
    Initialized: props<{ payload: string }>(),
  },
});
